import { useEffect, useState } from "react";

import { observer } from "mobx-react";

import useAuth from "../../hooks/useAuth";
import { envVarStore } from "../../utils/mobx/EnvVarStore";
import { staticLabelStore } from "../../utils/mobx/StaticLabelStore";

const Sidebar = observer(() => {
  const [pathName, setPathName] = useState("");
  const { auth } = useAuth();
  const { staticLabels } = staticLabelStore;
  const { loginRequired } = envVarStore;

  const handleClick = (path: string) => {
    window.location.href =
      auth.user || loginRequired === "false" ? path : `/before-login/${path}`;
    setPathName(path);
  };

  useEffect(() => {
    setPathName(window.location.pathname);
  }, [pathName]);

  return (
    <aside className="z-20 h-full bg-subtle">
      <nav className="w-[284px] px-[12px] py-[16px]">
        <div className="flex w-full flex-col gap-0.5">
          {staticLabels?.Sidebar?.Model?.Chat?.[1] && (
            <span
              className={`flex h-10 cursor-pointer items-center rounded px-3 font-bold ${
                pathName === "/chat"
                  ? "bg-muted text-foreground"
                  : "text-muted-dark"
              }`}
              onClick={() => handleClick("/chat")}
            >
              {staticLabels.Sidebar.Model.Chat[0]}
            </span>
          )}
          {staticLabels?.Sidebar?.Model?.DP?.[1] && (
            <span
              className={`flex h-10 cursor-pointer items-center rounded px-3 font-bold ${
                pathName === "/la"
                  ? "bg-muted text-foreground"
                  : "text-muted-dark"
              }`}
              onClick={() => handleClick("/la")}
            >
              {staticLabels.Sidebar.Model.DP[0]}
            </span>
          )}
          {staticLabels?.Sidebar?.Model?.OCR?.[1] && (
            <span
              className={`flex h-10 cursor-pointer items-center rounded px-3 font-bold ${
                pathName === "/ocr"
                  ? "bg-muted text-foreground"
                  : "text-muted-dark"
              }`}
              onClick={() => handleClick("/ocr")}
            >
              {staticLabels.Sidebar.Model.OCR[0]}
            </span>
          )}
          {staticLabels?.Sidebar?.Model?.KIE?.[1] && (
            <span
              className={`flex h-10 cursor-pointer items-center rounded px-3 font-bold ${
                pathName === "/kie"
                  ? "bg-muted text-foreground"
                  : "text-gray-400"
              }`}
              onClick={() => handleClick("/kie")}
            >
              {staticLabels.Sidebar.Model.KIE[0]}
            </span>
          )}
        </div>
      </nav>
    </aside>
  );
});

export default Sidebar;
